"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var client_1 = require("react-dom/client");
var app_1 = __importDefault(require("./components/app"));
var root = (0, client_1.createRoot)(document.getElementById('app'));
root.render((0, app_1.default)());
